import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _AcademicEducation, _PersonalReferences, _PersonDocuments } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";
import { FileService } from "../../../../../core/services/FileService";
import { FileInput } from "../../../../theme/Component/FileInput";



interface Props {
    Account: number;
}

export const PersonDocuments = ({ Account }: Props) => {

    const PersonDocuments = useDataBean(_PersonDocuments);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const fileService = new FileService();
    useEffect(() => {
        getLista();
    }, [Account])

    const getLista = () => {
        PersonDocuments.instance.getPersonDocumentsCatalogPorPropiedades({ State: 1, IDAccount: Account }, null).then(
            (resp: any) => {
                if (resp) {
                    let tmp = resp;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>DESCARGAR DOCUMENTO</a>`;
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    setLista(tmp);
                } else {
                    setLista([]);
                }
            }
        );
    }
    const create = () => {
        PersonDocuments.setBean({
            IDAccount: Account,
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        PersonDocuments.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        PersonDocuments.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }
    const head = [
        { title: 'ID', property: 'IDPersonDocuments', visible: true },
        { title: 'Ver / Descargar Documento', property: 'URL', visible: true },
        { title: 'Nombre Documento', property: 'DocumentName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={PersonDocuments.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-6">
                            <FileInput
                                label='Documento Soportes'
                                directory='DocHojavida'
                                onCreate={({ Media, MediaContext }) => { PersonDocuments.setBean({ ...PersonDocuments.bean, "Media": Media, "MediaContext": MediaContext }) }}
                            />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}